import Shader from './Shader';
import * as Uniform from '../Uniform';
import FXAA_VERT from './Vertex/fxaa.vert';
import FXAA_FRAG from './Fragment/fxaa.frag';

export default class FxaaShader extends Shader {
	public u_size:Uniform.Uniform2f;

	public vert = ():string => FXAA_VERT;
	public frag = ():string => FXAA_FRAG;
}